import {useQuery} from '@tanstack/react-query';
import proposalFetchers, {ProposalAnswer} from '@/api/fetchers/proposal';

const PROPOSAL_ANSWERS_QUERY_KEY = 'proposalAnswers';

function useProposalAnswersQuery(proposalId: string | null) {
  const response = useQuery<ProposalAnswer[]>({
    queryKey: [PROPOSAL_ANSWERS_QUERY_KEY, proposalId],
    queryFn: () => proposalFetchers.answers(proposalId as string),
    enabled: !!proposalId,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  return {
    answers: response.data ?? [],
    isLoading: response.isLoading,
  };
}

export default useProposalAnswersQuery;
